// @ai-generated 2026-09-17T10:27:43+00:00 by niklas.eicker@tngtech.com using Claude Opus 5 (1M context)
import { useAgenticOrchestratorRepository } from '@Hooks/useRepository';
import { ChatThreadsRepository } from '@Repositories/AgenticOrchestrator';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { toAgentMessage } from './toAgentMessage';

/**
 * The stored messages of one conversation, in the shape the AG-UI agent resumes from. `messages`
 * stays undefined until they are in hand, which a failed request does too.
 */
export function useChatTranscript(conversationId: string) {
    const chatThreads = useAgenticOrchestratorRepository(ChatThreadsRepository);

    const { data, error, refetch } = useQuery({
        queryKey: ['agentic-orchestrator', 'chat_threads', conversationId, 'transcript'],
        queryFn: () => chatThreads.getTranscript(conversationId),
        enabled: conversationId !== '',
        staleTime: Infinity,
    });

    const messages = useMemo(() => data?.data?.messages.map(toAgentMessage), [data]);

    return { messages, error, refetch };
}
